import React from "react";
import Input from "../../shared/Input";
import styles from "./FilterValues.module.scss";
import { OPTIONS } from "../../../constants";
import { useDispatch, useSelector } from "react-redux";
import { setDistanceType } from "../../../store/actions";
import { distanceTypeSelector } from "../../../store/selectors";

const FilterValues: React.FC = () => {
  const dispatch = useDispatch();
  const distanceType = useSelector(distanceTypeSelector);
  const handleInputChange = (e: any) => {
    const value = e.target.dataset.attribute;
    dispatch(setDistanceType(value));
  };

  const renderOptions = OPTIONS.map((option) => (
    <div key={option.key} className={styles.filter_values__radio}>
      <label className={styles.filter_values__radio__label}>
        <Input
          className={styles.filter_values__radio__input}
          type="radio"
          placeholder=""
          value=""
          dataAttribute={option.value}
          checked={distanceType === option.value}
          onChange={handleInputChange}
        />
        {option.title}
      </label>
    </div>
  ));

  return <div className={styles.filter_values}>{/* {renderOptions} */}</div>;
};

export default FilterValues;
